import CustomButton from "components/Atoms/CustomButton"
import NoResults from "components/Organisms/NoResults"
import React, { useCallback } from "react"
import { useNavigate } from "react-router-dom"

const NoContract = ({ vehicle }) => {
  const navigate = useNavigate()
  const handleClick = useCallback(() => {
    navigate(`/d/registration/contract/new`, { state: vehicle })
  }, [navigate, vehicle])
  return (
    <div className="h-full w-full flex justify-center items-center">
      <NoResults
        icon="cross"
        action={
          <CustomButton icon="plus" text="Add Contract" onClick={handleClick} />
        }
        title="There is no contract running for this vehicle, please add one before continuing"
      />
    </div>
  )
}

export default NoContract
